import { api } from "..";
import { QueryProps } from "@/types/Api";
import { CashoutOffers } from "@/types/ApiResponses/Cashout";

export interface GetCashoutOffersParams {
  // At most CASHOUT_OFFERS_MAX_COUPONS ids per request.
  ids: string[];
}

// GET /coupon-new/cashout-offers?ids=1&ids=2 (repeated keys: the client's
// paramsSerializer uses `indexes: null`).
export const getCashoutOffers = async (
  props: QueryProps<GetCashoutOffersParams>
): Promise<CashoutOffers> => {
  const res = await api.client.get("/coupon-new/cashout-offers", {
    signal: props.signal,
    params: { ids: props.params.ids },
  });
  return res.data;
};
